export function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function isSafari() {
  return (
    navigator.userAgent.indexOf('Safari') != -1 &&
    navigator.userAgent.indexOf('Chrome') == -1
  );
}

export function isStorageAvailable() {
  try {
    const value = 'test';
    const key = 'TEST';
    localStorage.setItem(key, value);
    const recoveredValue = localStorage.getItem(key);
    localStorage.removeItem(key);

    return recoveredValue === value;
  } catch (e) {
    return false;
  }
}

export const menusPersonalLoan = [
  {
    url: '/ecred/emprestimo-pessoal',
    key: 'emprestimo-pessoal',
    label: 'Empréstimo pessoal online',
  },
  {
    url: '/ecred/emprestimo-com-garantia-de-imovel',
    key: 'emprestimo-com-garantia-de-imovel',
    label: 'Empréstimo com garantia de imóvel',
  },
  {
    url: '/ecred/parceiros/emprestimo-com-garantia-de-celular',
    key: 'emprestimo-com-garantia-de-celular',
    label: 'Empréstimo com garantia de celular',
  },
  {
    url: '/ecred/emprestimos/emprestimo-com-garantia-de-veiculo',
    key: 'emprestimo-com-garantia-de-veiculo',
    label: 'Empréstimo com garantia de veículo',
  },
  {
    url: '/ecred/emprestimo-para-autonomo',
    key: 'emprestimo-para-autonomo',
    label: 'Empréstimo para autônomo',
  },
  {
    url: '/ecred/emprestimo-para-autonomo-negativado',
    key: 'emprestimo-para-autonomo-negativado',
    label: 'Empréstimo para autônomo negativado',
  },
  {
    url: '/ecred/emprestimo-sem-comprovacao-de-renda',
    key: 'emprestimo-sem-comprovacao-de-renda',
    label: 'Empréstimo sem comprovação de renda',
  },
  {
    url: '/ecred/emprestimo-para-negativado',
    key: 'emprestimo-para-negativado',
    label: 'Empréstimo para negativado',
  },
  {
    url: '/ecred/simulador',
    key: 'simulador',
    label: 'Simulador de empréstimo online',
  },
];

export const menusCreditCard = [
  {
    url: '/ecred/cartao-de-credito',
    key: 'cartao-de-credito',
    label: 'Cartão de crédito',
  },
  {
    url: '/ecred/cartao-de-credito-consignado',
    key: 'cartao-de-credito-consignado',
    label: 'Cartão de crédito consignado',
  },
  {
    url: '/ecred/cartao-pre-pago',
    key: 'cartao-pre-pago',
    label: 'Cartão pré-pago',
  },
];



// WEBPACK FOOTER //
// ./src/utils.js